import { SpecialOffersFields } from "./fields.definitions";

const fieldsMock: SpecialOffersFields = {
  "Title": {
    "value": "Special offers"
  },
  eyebrow: {
    value: 'OPTIONAL EYEBROW',
  },
  "link":{
    "value":{
      "href":"",
      "text":"OPTIONAL CTA",
      "linktype":"external",
      "url":"",
      "anchor":"",
      "target":""
    },
  },
  "Subtitle": {
    "value": " offers a wide variety of agricultural machinery products that are designed to improve productivity​​​​​​ for farmers and contractors. Explore our special offers!"
  },
  "Cards": [
    {
      "fields": {
        "Label": {
          "value": "TRACTORS"
        },
        "Badge Link": {
          "value": {
            href: "/products/tractors",
            text: "TRACTORS"
          }
        },
        "Button Primary": {
          "value": {
            "href": "/special-offer-detail?seriesGuid=bed8078b-804d-4409-9bbe-8c7094820f46",
            "text": "VIEW ALL",
            "url": "/special-offer-detail?seriesGuid=bed8078b-804d-4409-9bbe-8c7094820f46",
            "title": "View all",
            "target": ""
          }
        },
        "Button Secondary": {
          "value": {
            "href": "/Pages/Build-and-Price-Iframe.aspx?series=STEIGER%20TRACTORS",
            "text": "BUILD & PRICE",
            "url": "/Pages/Build-and-Price-Iframe.aspx?series=STEIGER%20TRACTORS",
            "title": "Build & price",
            "target": ""
          }
        },
        "Card Type": {
          "fields": {
            "Key": {
              "value": "offerCardWide"
            },
            "Phrase": {
              "value": "Offer Card Wide"
            }
          }
        },
        "Title": {
          "value": "<h3>2.75%</h3> <b>Mocked fixed rate for 60 months</b>"
        },
        "Subtitle": {
          "value": "<b>on a Steiger® tractor</b>"
        },
        "Image": {
          "value": {
            "src": "//localhost:8085/images/Steiger 420 with Early Riser 1255_GPS-0331_07-14_mr 1.jpg",
            "alt": "",
            "width": 664,
            "height": 240
          }
        }
      }
    },
    {
      "fields": {
        "Label": {
          "value": "TRACTORS"
        },
        "Badge Link": {
          "value": {
            href: "/products/tractors",
            text: "TRACTORS"
          }
        },
        "Button Primary": {
          "value": {
            "href": ""
          }
        },
        "Button Secondary": {
          "value": {
            "href": "/products/tractors/optum-series",
            "text": "EXPLORE OFFER",
            "url": "/products/tractors/optum-series",
            "title": "Explore Offer",
            "target": ""
          }
        },
        "Card Type": {
          "fields": {
            "Key": {
              "value": "offerCardNarrow"
            },
            "Phrase": {
              "value": "Offer Card Narrow"
            }
          }
        },
        "Title": {
          "value": "<h3>2.75%</h3> <b>fixed rate for 60 months</b>"
        },
        "Subtitle": {
          "value": "<b>for Optum™ series</b>"
        },
        "Image": {
          "value": {
            "src": "//localhost:8085/images/SpecialOffers_1.jpg",
            "alt": "",
            "width": 664,
            "height": 240
          }
        }
      }
    },
    {
      "fields": {
        "Label": {
          "value": "BALERS"
        },
        "Badge Link": {
          "value": {
            href: "/products/tractors",
            text: "TRACTORS"
          }
        },
        "Button Primary": {
          "value": {
            "href": ""
          }
        },
        "Button Secondary": {
          "value": {
            "href": "/Pages/Build-and-Price-Iframe.aspx?series=SQUARE%20BALERS",
            "text": "BUILD & PRICE",
            "url": "/Pages/Build-and-Price-Iframe.aspx?series=SQUARE%20BALERS",
            "title": "Build & price",
            "target": ""
          }
        },
        "Card Type": {
          "fields": {
            "Key": {
              "value": "offerCardNarrow"
            },
            "Phrase": {
              "value": "Offer Card Narrow"
            }
          }
        },
        "Title": {
          "value": "<h3>0%</h3> <b>for 48 months</b>"
        },
        "Subtitle": {
          "value": "<b>on Large Square Balers</b>"
        },
        "Image": {
          "value": {
            "src": "//localhost:8085/images/SpecialOffers_2.jpg",
            "alt": "",
            "width": 664,
            "height": 240
          }
        }
      }
    },
    {
      "fields": {
        "Label": {
          "value": "TRACTORS"
        },
        "Badge Link": {
          "value": {
            href: "/products/tractors",
            text: "TRACTORS"
          }
        },
        "Button Primary": {
          "value": {
            "href": ""
          }
        },
        "Button Secondary": {
          "value": {
            "href": "/products/tractors/vestrum-series",
            "text": "EXPLORE OFFER",
            "url": "/products/tractors/vestrum-series",
            "title": "Explore offer",
            "target": ""
          }
        },
        "Card Type": {
          "fields": {
            "Key": {
              "value": "offerCardNarrow"
            },
            "Phrase": {
              "value": "Offer Card Narrow"
            }
          }
        },
        "Title": {
          "value": "<h3>0%</h3> <b>for 48 months</b>"
        },
        "Subtitle": {
          "value": "<b>on a Vestrum® series tractor</b>"
        },
        "Image": {
          "value": {
            "src": "//localhost:8085/images/SpecialOffers_3.png",
            "alt": "",
            "width": 664,
            "height": 240
          }
        }
      }
    },
    {
      "fields": {
        "Label": {
          "value": "HARVESTING"
        },
        "Badge Link": {
          "value": {
            href: "/products/tractors",
            text: "TRACTORS"
          }
        },
        "Button Primary": {
          "value": {
            "href": ""
          }
        },
        "Button Secondary": {
          "value": {
            "href": "/tools-resources/build-price",
            "text": "BUILD & PRICE",
            "url": "/tools-resources/build-price",
            "anchor": "",
            "target": ""
          }
        },
        "Card Type": {
          "fields": {
            "Key": {
              "value": "offerCardNarrow"
            },
            "Phrase": {
              "value": "Offer Card Narrow"
            }
          }
        },
        "Title": {
          "value": "<h3>0%</h3> <b>for 48 months</b>"
        },
        "Subtitle": {
          "value": "<b>on a new  Draper Header</b>"
        },
        "Image": {
          "value": {
            "src": "//localhost:8085/images/SpecialOffers_4.png",
            "alt": "Vestrum Series",
            "width": 664,
            "height": 240
          }
        }
      }
    }
  ]
};

export default fieldsMock;

